<template>
  <q-page>
    <Gr :id="id" />
  </q-page>
</template>

<script setup>
import Gr from "../components/gr/Gr.vue";
import { useRoute } from "vue-router";
import { computed } from "vue";
const route = useRoute();
const id = computed(() => route.params?.id);
</script>
